<template>
  <div class="composite">

  </div>
</template>

<script>
export default {
  name: 'FieldComposite',
  props: ['data']
}
</script>



// WEBPACK FOOTER //
// FieldComposite.vue?d3ec63ce